import { render, staticRenderFns } from "./display-field-days.vue?vue&type=template&id=3aae7285&scoped=true&"
import script from "./display-field-days.ts?vue&type=script&lang=ts&"
export * from "./display-field-days.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-days.scss?vue&type=style&index=0&id=3aae7285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae7285",
  null
  
)

export default component.exports